<template >
   <div>
      <Breadcrumbs main="Product" title="Product Details" />
         <div  class="container-fluid">
            <div class="row">
               <div class="col-sm-12">
                  <div class="card">
                     <div class="card-body">
                        <!-- <div class="row float-end">
                              <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='fa fa-chevron-left'></i> Back</a>
                        </div> -->
                        <div class="row">
                           <div class="col-md-10 d-flex">
                                 <h4 class="card-title">Product Details</h4>
                           </div>
                              
                           <div class="col-md-2">
                              <h6>Status: 
                                 <span class="text-danger" v-if="product.status==0">Blocked</span>
                                 <span class="text-green" v-if="product.status==1">Active</span>
                                 <span class="text-info" v-if="product.status==2">Requested</span>
                              </h6>
                           </div>
                        </div>
                              
                        <div>
                           <div class="details mt-3">
                              <div class="row">
                                 <div class="col-md-6 lg-4 ">
                                    <h6>Ad. ID:</h6>
                                    <p>{{product.ad_id}}</p>
                                 </div >

                                 <div class="col-md-6 lg-4">
                                    <h6>Title:</h6>
                                    <p>{{product.title}}</p>
                                 </div > 

                                 <div class="col-md-6 lg-4 mt-3">
                                    <h6>Price:</h6>
                                    <p>Rs. {{product.price}}</p>                 
                                 </div > 

                                 <div class="col-md-6 lg-4 mt-3">
                                    <h6>Category:</h6>
                                    <p>{{product.cat_name}}</p>                               
                                 </div >

                                 <div class="col-md-6 lg-4 mt-3">
                                    <h6>Brand:</h6>
                                    <p>{{product.brand_name}}</p>                             
                                 </div >   

                                 <div class="col-md-6 lg-4 mt-3">
                                    <h6>Model:</h6>
                                    <p>{{product.model_name}}</p>                             
                                 </div >   

                                 <div class="col-md-12 mt-3">
                                    <h6>Description:</h6>
                                    <p>{{product.description}}</p>
                                 </div > 
                              </div >
                           </div>
                        </div >
                     </div>
                  </div>

                  <div class="card">
                     <div class="card-body">
                        <div class="row">
                           <h6 class="card-title">Attributes</h6>
                        </div>
                        <div>
                           <div class="details mt-3">  
                              <div class="row">
                                 <div class="col-md-6 lg-3" v-for="attribute in product.attributes" :key="attribute.id">
                                    <h6>{{attribute.attribute_name}}</h6>
                                    <p>{{attribute.value}}</p>
                                 </div >
                              </div>
                           </div>               
                        </div>    
                     </div>
                  </div>
 
                  <div class="card">
                     <div class="card-body">
                        <div class="row">
                           <h6 class="card-title">Location</h6>
                        </div >
                        <div class="details mt-3">  
                           <div class="row">                          
                              <div class="col md-12 lg-12">
                                 <p>{{product.location}}</p>                              
                              </div> 
                           </div>
                           <div  class="col md-12 lg-12">
                              <div class="gmap_canvas">
                                 <iframe class="gmap_iframe" width="100%" height="300px" frameborder="0" scrolling="no" marginheight="0"
                                          marginwidth="0" :src="getMapUrl()"></iframe >
                              </div>
                           </div>
                        </div>
                     </div>  
                  </div> 

                  <div class="card">
                     <div class="card-body">
                        <div class="row">
                           <h6 class="card-title">User Details</h6>
                        </div >
                     
                        <div class="details mt-3">  
                           <div class="row">
                              <div class="col-md-6 lg-4">                              
                                 <img :src="$image_url + product.user_image" alt="Image" style="width:130px">
                              </div > 

                              <div class="col md-6 lg-4">
                                 <h6>Name:</h6>
                                 <p>{{product.user_name}}</p>
                                 <h6>Contact</h6>
                                 <p class="mb-0">{{product.country_code}} {{product.user_phone}}</p>
                                 <p>{{product.user_email}}</p>
                              </div> 

                              <div class="col md-6 lg-3 ">
                                 <h6>Posted on:</h6>
                                 <p>{{$filters.formatDateTime(product.created_at)}}</p>
                                 <h6>Last updated on:</h6>
                                 <p>{{$filters.formatDateTime(product.updated_at)}}</p>
                              </div> 

                           </div >
                        </div>
                     </div>
                  </div>

                  <div class="card">
                     <div class="card-body">
                        <div row>
                           <h6 class="card-title">Images</h6>
                        </div >

                        <div class="details mt-3">
                           <div class="row">
                              <div class="col-md-6 lg-3" v-for="img in product.images" :key="img.image">
                                    <img :src="$image_url + img.image" alt="Image" style="width:150px">
                              </div >
                           </div >
                        </div >
                     </div>
                  </div>

                  <div class="card" v-if="product.video">
                     <div class="card-body" v-if="Boolean(product.video.length)">
                        <div class="row">
                              <h6 class="card-title">Video</h6>
                           </div >
                        
                           <div class="details mt-3">
                              <div class="row">
                                 <div class="col-md-7">
                                    <b-embed type="video" controls v-for="video in product.video" :key="video.video">
                                       <source :src="$image_url + video.video" type="video/mp4">
                                    </b-embed>
                                 </div >
                              </div >
                        </div>
                     </div >
                  </div>

               </div >
            </div >
         </div >
   </div>
</template >
<script>
export default {
   name:'ProductDetails',
   data() {
      return {
         product: {},         
         
         product_status: {
            id: "",
            status: ""
         },  

         marker: { position: { lat: 10, lng: 10 } },
         center: { lat: 10, lng: 10 },

         mapOptions: {
            disableDefaultUI: true,
         },              
         
         token: '',
         errors: {}
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchProduct();
   },

   methods: {
      
      fetchProduct() {
          let url = '/api/admin/products/show?product_id=' + this.$route.params.id ;
            
         this.getToken();
         this.$axios
            .get(url, {headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;               
               this.product = responseData; 
               this.marker.position.lat = parseFloat(this.product.latitude);
               this.marker.position.lng = parseFloat(this.product.longitude);

               this.center.lat = parseFloat(this.product.latitude);
               this.center.lng = parseFloat(this.product.longitude);
               console.log(this.product);             
            })
            .catch(err => console.log(err));
      },   

      getMapUrl() {
            return `https://maps.google.com/maps?q=${this.center.lat},${this.center.lng}&z=15&output=embed`;
      },

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

      
   }   
}
</script>